export const scrollPivotElementToLatest = (element) => {
    if (!element) return 0;

    const maxScroll = Math.max(0, element.scrollWidth - element.clientWidth);
    element.scrollLeft = maxScroll;
    return maxScroll;
};

export const scrollPivotTablesToLatest = (root) => {
    const scope = root ?? document;
    if (!scope?.querySelectorAll) return;

    scope.querySelectorAll('.mtska-pivot-scroll').forEach(scrollPivotElementToLatest);
};

export const waitForPivotTablesScrolledToLatest = (root, { attempts = 8, intervalMs = 120 } = {}) =>
    new Promise((resolve) => {
        const scope = root ?? document;
        if (!scope?.querySelectorAll) {
            resolve();
            return;
        }

        const scrollTargets = Array.from(scope.querySelectorAll('.mtska-pivot-scroll'));
        if (scrollTargets.length === 0) {
            resolve();
            return;
        }

        let attempt = 0;
        const tick = () => {
            scrollTargets.forEach(scrollPivotElementToLatest);
            attempt += 1;

            const pending = scrollTargets.some((element) => {
                const maxScroll = Math.max(0, element.scrollWidth - element.clientWidth);
                return maxScroll > 0 && element.scrollLeft < maxScroll - 1;
            });

            if (!pending || attempt >= attempts) {
                resolve();
                return;
            }

            window.setTimeout(tick, intervalMs);
        };

        requestAnimationFrame(() => {
            tick();
        });
    });

export const bindPivotScrollToLatest = (element) => {
    if (!element) {
        return () => {};
    }

    const apply = () => scrollPivotElementToLatest(element);
    const timers = [0, 120, 300, 600].map((delay) => window.setTimeout(apply, delay));
    const resizeObserver = typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(apply)
        : null;

    apply();
    resizeObserver?.observe(element);
    if (element.firstElementChild) {
        resizeObserver?.observe(element.firstElementChild);
    }

    return () => {
        timers.forEach((timerId) => window.clearTimeout(timerId));
        resizeObserver?.disconnect();
    };
};
